import type React from 'react';
import { useEffect } from 'react';

import { useAtomValue } from 'jotai';
import { Navigate, useParams } from 'react-router-dom';

import { eventTournamentIdAtomFamily, firstFlightDrawIdAtomFamily } from 'atoms/events';
import { ScorecardTemplateOverlay, SplitDrawsContainer } from 'components/Lazyload';
import { getDrawRoute } from 'config/router/utils';

export const DrawPanel: React.FC = () => {
  const { eventId } = useParams<{ tournamentId: string; eventId: string }>();
  const tournamentId = useAtomValue(eventTournamentIdAtomFamily(eventId));
  const firstFlightDrawId = useAtomValue(firstFlightDrawIdAtomFamily(eventId));

  useEffect(() => {
    ScorecardTemplateOverlay.preload();
    SplitDrawsContainer.preload();
  }, []);

  return firstFlightDrawId ? (
    <Navigate replace to={getDrawRoute(tournamentId, eventId, firstFlightDrawId)} />
  ) : (
    <SplitDrawsContainer />
  );
};

export default DrawPanel;
